"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ethers_1 = require("ethers");

var Web3 = require("web3"); // general functions to manage providers/libraries


function getNewLibraryFromURL(libraryName, providerURL) {
  // TODO this could/should probably be refactored on a per-libraryName basis
  var provider = new Web3.providers.HttpProvider(providerURL);
  return getNewLibraryFromProvider(libraryName, provider);
}

exports.getNewLibraryFromURL = getNewLibraryFromURL;

function getNewLibraryFromProvider(libraryName, provider) {
  switch (libraryName) {
    case 'web3.js':
      return new Web3(provider);

    case 'ethers.js':
      return new ethers_1.ethers.providers.Web3Provider(provider);
  }
}

exports.getNewLibraryFromProvider = getNewLibraryFromProvider;

function isWeb3(library) {
  return library.version === '1.0.0-beta.34';
}

exports.isWeb3 = isWeb3; // a few specific functions that cut across libraries

function getNetworkId(library) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (isWeb3(library)) {
        return [2
        /*return*/
        , library.eth.net.getId()];
      } else {
        return [2
        /*return*/
        , library.getNetwork().then(function (network) {
          return network.chainId;
        })];
      }

      return [2
      /*return*/
      ];
    });
  });
}

exports.getNetworkId = getNetworkId;

function getAccounts(library) {
  if (isWeb3(library)) {
    return library.eth.getAccounts();
  } else {
    if (!(library instanceof ethers_1.ethers.providers.JsonRpcProvider)) {
      throw Error('This function can only be called with a JsonRpcProvider.');
    }

    return library.listAccounts();
  }
}

exports.getAccounts = getAccounts;